<template>
  <header class="main-header" :class="{ scrolled: isScrolled }">
    <nav class="nav-container">
      <!-- 网站Logo -->
      <router-link to="/" class="logo">
        <img 
          :src="logoImage" 
          :alt="siteName + ' Logo'" 
          class="logo-image" 
          @error="handleImageError"
          v-show="showImage"
        >
        <i :class="logoIcon" v-show="!showImage"></i>
        <span>{{ siteName }}</span>
      </router-link>
      
      <!-- 主导航菜单 -->
      <ul class="nav-menu" :class="{ active: isMobileMenuOpen }" id="navMenu">
        <li v-for="item in menuItems" :key="item.id">
          <router-link 
            :to="item.link" 
            class="nav-link"
            :class="{ active: isActiveRoute(item.link) }"
            @click="closeMobileMenu"
          >
            {{ item.name }}
          </router-link>
        </li>
      </ul>
      
      <!-- 移动端菜单按钮 -->
      <div 
        class="hamburger" 
        :class="{ active: isMobileMenuOpen }"
        @click="toggleMobileMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'NavbarComponent',
  
  data() {
    return {
      siteName: '非遗索思',
      logoImage: 'img/logo.png',
      logoIcon: 'fas fa-seedling',
      showImage: true,
      isMobileMenuOpen: false,
      isScrolled: false,
      
      menuItems: [
        { name: '首页', link: '/', id: 'home' },
        { name: '寻迹识非遗', link: '/about', id: 'about' },
        { name: '科学解非遗', link: '/explore', id: 'explore' },
        { name: '实践传非遗', link: '/heritage', id: 'heritage' },
        { name: '个人中心', link: '/profile', id: 'profile' }
      ]
    }
  },
  
  mounted() {
    this.initScrollBehavior()
    this.initClickOutside()
  },
  
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  },
  
  methods: {
    /**
     * 处理图片加载失败
     */
    handleImageError() {
      this.showImage = false
    },
    
    /**
     * 切换移动端菜单
     */
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    
    /**
     * 关闭移动端菜单
     */
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    
    /**
     * 判断是否为当前激活路由
     * @param {string} route - 路由路径
     * @returns {boolean} 是否激活
     */
    isActiveRoute(route) {
      // 直接路径匹配
      if (this.$route.path === route) {
        return true
      }
      
      // 特殊路径映射处理
      const currentPath = this.$route.path
      
      // longzhou-teaching页面应该激活"科学解非遗"菜单项
      if (route === '/explore' && currentPath === '/longzhou-teaching') {
        return true
      }
      
      // longzhou页面也应该激活"科学解非遗"菜单项
      if (route === '/explore' && currentPath === '/longzhou') {
        return true
      }
      
      return false
    },
    
    /**
     * 初始化滚动行为
     */
    initScrollBehavior() {
      this.handleScroll = () => {
        this.isScrolled = window.pageYOffset > 50
      }
      
      window.addEventListener('scroll', this.handleScroll, { passive: true })
    },
    
    /**
     * 初始化点击外部关闭菜单
     */
    initClickOutside() {
      this.handleClickOutside = (e) => {
        const navMenu = document.getElementById('navMenu')
        const hamburger = e.target.closest('.hamburger')
        
        if (!hamburger && navMenu && !navMenu.contains(e.target)) {
          this.isMobileMenuOpen = false
        }
      }
      
      document.addEventListener('click', this.handleClickOutside)
    }
  },
  
  watch: {
    /**
     * 监听路由变化，设置当前页面
     */
    '$route'(to) {
      this.$store.dispatch('setCurrentPage', to.name || 'home')
    }
  }
}
</script>

<style scoped>
/* 组件特定样式，其他样式通过全局CSS文件加载 */
.nav-link.router-link-active {
  color: #FFCCC;
}

.nav-link.router-link-active::before {
  opacity: 1;
  transform: scaleX(1);
}

.nav-link.router-link-active::after {
  opacity: 1;
  transform: scale(1);
}
</style> 